// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modalStyle .ant-modal-content {\n  border: 2px solid rgb(16, 24, 64) !important;\n  padding: 0 !important;\n  \n}\n", ""]);
// Exports
module.exports = exports;
